<template>
  <div class="section">
    <div class="toolbar">
      <div class="section-title">支付明细</div>
      <!-- <el-button size="small" type="warning" icon="el-icon-download" style="margin-left: auto;" @click="handleExport"
        >导出</el-button
      > -->
    </div>
    <el-table
      :data="tableData"
      border
      stripe
      size="small"
      show-summary
      :summary-method="getSummaries"
      v-loading="loading"
    >
      <el-table-column label="序号" width="60" type="index" fixed></el-table-column>
      <el-table-column prop="settleDate" label="支付时间" min-width="170" sortable></el-table-column>
      <el-table-column prop="settlePurchaseNo" label="支付单号" min-width="180" sortable></el-table-column>
      <el-table-column prop="settleCurr" label="支付金额" min-width="130" sortable>
        <template slot-scope="scope">￥{{ scope.row.settleCurr }}</template>
      </el-table-column>
      <el-table-column prop="settleDiscount" label="优惠" min-width="110" sortable>
        <template slot-scope="scope">￥{{ scope.row.settleDiscount }}</template>
      </el-table-column>
      <el-table-column prop="settleType" label="支付方式" min-width="130" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { settleList } from "@/api/reconciliation";
export default {
  name: "PayDetailSection",
  props: {
    purchaseNo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      loading: false
    };
  },
  watch: {
    purchaseNo: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 合计行计算方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["settleCurr", "settleDiscount"];
        if (sumFields.includes(prop)) {
          const values = data.map(item => {
            // 处理带货币符号的字符串
            let val = item[prop];
            if (typeof val === "string") {
              // 移除货币符号、逗号等，转换为数字
              val = val.replace(/[¥$,]/g, "");
            }
            return Number(val) || 0;
          });
          const sum = values.reduce((prev, curr) => prev + curr, 0);
          sums[index] = "￥" + sum.toFixed(2);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    // 导出方法
    handleExport() {
      this.$message.success("导出支付明细");
    },
    getList() {
      this.loading = true;
      settleList({
        statementBillNo: this.purchaseNo,
        page: 1,
        pageSize: 500
      })
        .then(res => {
          console.log("支付明细", res);
          this.tableData = res.rows || [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.section {
  margin-bottom: 0;
  padding-bottom: 0;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333333;
}
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  background: rgb(249, 249, 249);
  padding: 12px 16px;
}
.toolbar-title {
  font-weight: 500;
  color: #1f2f3d;
}

/* 合计行样式 */
.el-table ::v-deep .el-table__footer-wrapper {
  font-weight: bold;
}
.el-table ::v-deep .el-table__footer-wrapper .el-table__footer td {
  background-color: #f5f7fa;
}
</style>
